import type { RequestListResponse, RequestRestService } from '~/services/RequestRestService'
import type { HttpClient } from '~/shared/api'
import { ApiService } from '~/shared/api'
import type { ApiDataResponse } from '~/shared/types/api'
import type { QueryParams } from '~/shared/interfaces/params'
import { VacancyModel } from '~/models/vacancy'
import type { CookieRef } from '#app'

export class VacanciesMainService extends ApiService {
  constructor(
    http: HttpClient,
    private readonly requestRestService: RequestRestService
  ) {
    super(http)
  }

  readonly urls = {
    vacancies: '/api/v1/yavagro/vacancies/',
  }

  async getVacanciesList(params: QueryParams, signal?: AbortSignal): Promise<RequestListResponse> {
    const res = await this.requestRestService.getList('vacancies', params, signal)
    return res
  }

  async getVacanciesSimilarList(id: number | string): Promise<Array<VacancyModel>> {
    return this.requestRestService.getList('vacancies', { vacancy: id }).then(({ data }) => {
      if (Array.isArray(data)) {
        return data.map(i => new VacancyModel(i))
      }

      return []
    })
  }

  async getVacanciesPageTitle(region: string): Promise<string> {
    const res = await this.http.request<ApiDataResponse<{ title: string }>>({
      url: `${this.urls.vacancies}title`,
      params: { region },
    })
    return res.data.data.title
  }

  private responsesCookie: CookieRef<number[]> | null = null


  private getResponsesCookie(): CookieRef<number[]> {
    this.responsesCookie ??= useCookie<number[]>('vacancies_responses', {
      default: () => [],
      maxAge: 60 * 60 * 24 * 365, // 1 год
      sameSite: 'lax',
      path: '/',
    })

    return this.responsesCookie
  }

  isVacancyInResponses(id: number): boolean {
    try {
      const cookie = this.getResponsesCookie()
      return (cookie.value || []).includes(id)
    } catch {
      return false
    }
  }

  setVacanciesResponseByUser(id: number): void {
    if (import.meta.server) {
      return
    }

    try {
      const cookie = this.getResponsesCookie()
      const currentResponses = cookie.value || []

      if (!currentResponses.includes(id)) {
        cookie.value = [...currentResponses, id]
      }
    } catch {
      // Игнорируем ошибки записи в куки
    }
  }

  getVacanciesResponses(): number[] {
    try {
      const cookie = this.getResponsesCookie()
      return cookie.value || []
    } catch {
      return []
    }
  }
}
